<template>
    <el-dialog title="通过" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="closeCallBack">
        <div>
            <el-form ref="form" label-width="84px">
    
                <el-form-item label="寄送方式" label-width="150px">
                    <el-radio-group v-model="Form.SendMode">
                        <el-radio v-for="item in transportList" :label="item.Id">{{item.ParmName}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="支付方式" label-width="150px">
                    <el-radio-group v-model="Form.PayMode">
                        <el-radio v-for="item in PayList" :label="item.Id">{{item.ParmName}}</el-radio>
                    </el-radio-group>
                </el-form-item>
    
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="suerAdoptGo">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { GetByAgentId } from '../../api/agentApi.js';
import NProgress from 'nprogress';
import { util } from '../../common/js/util.js';
import { lg } from 'utils';
import { GetOrderAuditByPage, ERP_AuditOrder, GetOrderAuditStatistics } from '../../api/orderApi';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig,
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '../../api/commonApi.js';

//组件

export default {
    props: {
    },
    data() {
        return {
            PayList: [],
            transportList: [],
            Form: {
                SendMode: 0,
                PayMode: 0
            },
            OrderId: "",
            dialogVisible: false
        }
    },
    components: {

    },
    methods: {
        show(OrderId, PayMode, SendMode) {
            this.dialogVisible = true;
            this.OrderId = OrderId;
            this.Form.PayMode = PayMode;
            this.Form.SendMode = SendMode;
        },
        closeCallBack() {
            this.Form.PayMode = this.PayList[0].Id;
            this.Form.SendMode = this.transportList[0].Id;
        },
        suerAdoptGo() {

            this.$confirm('确认通过该订单吗？', '提示', {
                type: 'warning'
            }).then(() => {
                NProgress.start();
                let para = {
                    Sid: this.$store.state.sysSid,
                    Session: this.$store.state.sysSession,
                    OrderId: this.OrderId,
                    OrderStatus: 1,
                    payModel: this.Form.PayMode,
                    SendModel: this.Form.SendMode
                };
                ERP_AuditOrder(para).then((response) => {
                    NProgress.done();
                    if (response.data.StateCode !== 0) {
                        this.$notify({
                            title: '错误',
                            message: response.data.StateMsg,
                            type: 'error'
                        });
                    } else {
                        this.$notify({
                            title: '成功',
                            message: '审核通过成功',
                            type: 'success'
                        });
                        this.$emit('refreshList');// 向上派发 toggle事件
                        this.dialogVisible = false;
                    }
                });
            }).catch(() => {

            });
        },
        /*
        支付：this.getPay(9);
        寄送：this.getPay(8);
        */
        getPay(type) {
            let Params = { Sid: this.$store.state.sysSid, Session: this.$store.state.sysSession, ParmType: type }
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 9) {
                        this.PayList = res.data.Data;
                        this.Form.PayMode = this.PayList[0].Id;
                    } else {
                        this.transportList = res.data.Data;
                        this.Form.SendMode = this.transportList[0].Id;
                    }
                }
                );
            });
        }
    },
    created() {
        this.getPay(9);
        this.getPay(8);
    }
}
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// adoptDialog.vue?cb73fe2e